import React from 'react'

function Activities() {
  return (
    <div className="app_act">
      <h1>Hey This is our Activities Section</h1>

      <div className="app__top">
        {/* image at top - logo*/}
        <img className="app__logo"
        src="">
        </img>
        {/* Reels text */}
      </div>

      <div className="app__videos">
        {/* Container of app__videos (scrollable container ) */}
      </div>





    </div>
  )
}

export default Activities